__turbopack_context__.v({
  "banner": "index-module-scss-module__7AiL3W__banner",
});
